'use strict';

var React = require('react');

var relativeDate = require('../../utils/relative-date');

var DateTime = React.createClass({
    render: function () {
        var time = relativeDate.humanizedDatetime(this.props.time);
        return (
            <span className='feed-post-time'>
                <i className='feed-post-time-icon gui-icon gui-icon-clock' />
                <span className='feed-post-time-label'>{time}</span>
            </span>
        );
    }
});

module.exports = DateTime;
